module.exports = __webpack_public_path__ + "images/emails/bg-envelope-l-905ece18.gif";